module.exports = __webpack_public_path__ + "img/018.76439162.png";